import { ReactElement, ReactNode } from 'react'
import create from 'zustand'
import createContext from 'zustand/context'
import { combine } from 'zustand/middleware'
import { StoreReInitializer } from 'src/state/utils'
import { validate } from '../middleware'
import { createInitialState } from '../utils'

interface Props {
  children: ReactNode
  assemblies: Assembly[]
  assemblyAssignment: AssemblyAssignment[]
  connections: ProjectConnection[]
  prioritization: ProjectConnectionPrioritization
}

interface ServerState {
  assemblies: Assembly[]
  assemblyAssignment: AssemblyAssignment[]
  connections: ProjectConnection[]
  prioritization: ProjectConnectionPrioritization
}

interface SystemManagerStoreType {
  assemblies: Assembly[]
  assemblyAssignment: AssemblyAssignment[]
  connections: ProjectConnection[]
  prioritization: ProjectConnectionPrioritization
  setPrioritization: (prio: ProjectConnectionPrioritization) => void
}

const initialState = {
  assemblies: [],
  assemblyAssignment: [],
  connections: [],
  prioritization: {},
}

const createAssemblyStoreState = (serverState: ServerState): SystemManagerStoreType => {
  return createInitialState(serverState, initialState)
}

const createStore = (serverState: ServerState) => {
  return create(
    validate(
      combine(createAssemblyStoreState(serverState), set => ({
        setPrioritization: (prioritization: ProjectConnectionPrioritization) =>
          set({ prioritization }),
      })),
    ),
  )
}

const {
  Provider,
  useStore: useSystemManagerStore,
  useStoreApi,
} = createContext<SystemManagerStoreType>()

const SystemManagerStoreProvider = ({ children, ...props }: Props): ReactElement => (
  <Provider createStore={() => createStore({ ...props })}>
    <StoreReInitializer data={props} storeApi={useStoreApi} />
    {children}
  </Provider>
)

export { SystemManagerStoreProvider, useSystemManagerStore }
